export default "__VITE_ASSET__fd26ca70__"